import { render, staticRenderFns } from "./sampleOpinion.vue?vue&type=template&id=438604e6"
import script from "./sampleOpinion.vue?vue&type=script&lang=js"
export * from "./sampleOpinion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports